import { render } from "./AttachmentScreen.vue?vue&type=template&id=5c507a12"
import script from "./AttachmentScreen.vue?vue&type=script&lang=js"
export * from "./AttachmentScreen.vue?vue&type=script&lang=js"

import "./AttachmentScreen.vue?vue&type=style&index=0&id=5c507a12&lang=css"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__